 
 <nb-card style="margin-bottom:1rem !important;" [nbSpinner]="deletingLoading"  >
 		<nb-card-header>

		 <span class="panelToggler"   [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('streamDownload')" (click)="panelVisibility.toggleVisibility('streamDownload')" >Завантажити запис трансляції</span>    
           	</nb-card-header>
                <nb-card-body  *ngIf="!panelVisibility.isUnvisible('streamDownload')" [@visibilityPanelAnimation]>


			<div class="flex">

				<div class="flex" style="flex:1; margin-right:15px">
					<nb-select  [(selected)]="selectedResolution" [disabled]="!stream.downloadInfo.resolutions?.length || linkLoading"   fullWidth [placeholder]="stream.downloadInfo.resolutions?.length ? 'Виберіть якість' : 'Немає запису'">
					      <nb-option *ngFor="let item of stream.downloadInfo.resolutions" [value]="item">{{item.resolution}}p.mp4</nb-option>
					    </nb-select>


				</div>

				<div>
					<button (click)="startDownload()" [disabled]="!selectedResolution || !stream.downloadInfo.resolutions?.length || linkLoading" [nbSpinner]="linkLoading" nbButton status="primary">ЗАВАНТАЖИТИ</button>

				</div>
			</div>


			<div class="flex" style="margin-top:15px">
				<div style="margin-right:25px">Розмір даних: {{stream.downloadInfo.size}} гб</div> <div *ngIf="stream.downloadInfo.resolutions?.length && !linkLoading && !rmhide"><a (click)="deleteRecordModal(deleteModal)" href="javascript:;" class="text-danger">Видалити запис</a></div>
			</div>

		</nb-card-body>

  </nb-card>












<ng-template #downloadModal  let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Завантаження запису</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>


	<div style="text-align:center; margin:10px;"><h6>Пряме посилання на скачування</h6></div>

	    <div style="display:flex; margin:20px auto 15px auto; ">
		 <div style="display:flex; width:100%; padding:15px; word-break: break-all; border-radius:4px;" class="themeBg2">{{downloadLinkBase}} </div>  
	 </div>

	    <div style="display:flex;  justify-content: center;">
  

       
            <a class="copyLink"  href="javascript:;"  (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
            ngxClipboard [cbContent]="downloadLinkBase">Копіювати посилання на скачування</a>
            
	 </div>
	
    <div style="display:flex; margin:35px auto ; ">
         
 <div style="display:flex; margin:auto; ">
	    <button nbButton (click)="downloadNow()" status="primary" >Завантажити {{downloadSize}}</button>
 </div>
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
 
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Закрити</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>













 <ng-template #deleteModal  let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Видалити запис трансляції?</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>
    <div>
        
         
      <p>Запис буде безповоротно видалено з наших серверів і перестане відтворюватися в плеєрі трансляції.
Ви дійсно хочете видалити запис трансляції?</p>
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="deleteRecord(ref)" nbButton status="danger" >Видалити запис</button>
            <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>
    
